// Dashboard Users translations (en-US), loaded into dashboard.users by ./en-US.js
module.exports = {
  label: "Users",
  gender: {
    M: "Male",
    F: "Female",
    O: "Other",
    N: "Not informed",
  },
  summary: require('./users/en-US.summary.js'),
  growth: require('./users/en-US.growth.js'),
  activity: require('./users/en-US.activity.js'),
  retention: require('./users/en-US.retention.js'),
  onboarding: require('./users/en-US.onboarding.js'),
  profile: require('./users/en-US.profile.js'),
  registration: require('./users/en-US.registration.js'),
  rankings: require('./users/en-US.rankings.js'),
};
